<template>
  <div class="flex items-center gap-2">
    <span
      v-if="hasDiscountedNightlyPrice"
      class="text-sm text-gray-500 line-through whitespace-nowrap"
    >
      {{ formatPrice({ value: baseNightlyPrice }) }}
    </span>
    <span>
      <span
        class="font-semibold text-base whitespace-nowrap"
       
      >{{ formatPrice({ value: actualNightlyPrice, showCurrencyCode: true }) }}</span>/{{ t('night') }}</span>

    <TBadge
      v-if="showDiscountBadge && discountPercentage > 0"
      class="ml-auto"
      variant="highlight"
    >
      {{ t('rv.discount', { discount: discountPercentage }) }}
    </TBadge>
  </div>
</template>

<script setup lang="ts">
import type { FinancialCommon, Nullable } from '~/types'

const props = defineProps<{
  financial?: Nullable<FinancialCommon>
  showDiscountBadge?: boolean
}>()

const { t } = useI18n()
const {
  financialNightlyBase,
  financialNightlyDiscounted,
  financialDiscountPercentage,
} = useFinancialData(computed(() => props.financial))

const {
  rvCountry,
  rvDefaultPrice,
  rvOriginalPrice,
  rvTotalDiscount,
} = useRvDetails()

const actualNightlyPrice = computed(() => {
  return financialNightlyDiscounted.value || financialNightlyBase.value || rvDefaultPrice.value
})

const baseNightlyPrice = computed(() => {
  return financialNightlyBase.value || rvOriginalPrice.value || rvDefaultPrice.value
})

const hasDiscountedNightlyPrice = computed(() => baseNightlyPrice.value > actualNightlyPrice.value)

const discountPercentage = computed(() => {
  if (props.financial) {
    return financialDiscountPercentage.value
  }

  return rvTotalDiscount.value?.Percentage ?? 0
})

const { priceDisplay } = usePrice()
function formatPrice({ value, showCurrencyCode }: { value: number, showCurrencyCode?: boolean }) {
  return priceDisplay({
    value,
    countryCode: rvCountry.value,
    round: true,
    showCurrencyCode,
  })
}
</script>

<i18n lang="json">
{
  "en": {
    "night": "night"
  },
  "fr": {
    "night": "nuit"
  }
}
</i18n>
